const pageNameKey = "bigBlueprintBanner";

export const bigBlueprintBannerEn = {
  [pageNameKey]: {
    smallOrangeText: "Tomorrow Things Exclusive",
    gradientText: "Easiest way of collecting your relevant data",
    findBlueprintButton: "Find Blueprint",
    findBlueprintButtonText: "Find Blueprint",
    bluePrintExampeAltText: "Blueprint Example",
    grayNotificationText: "You can restore your current structure anytime.",
    grayNotificationAltText: "Gray Lock",
    checkedList: {
      firstElement: "Hundreds of pre-configured blueprints",
      secondElement: "Applied and automatically connected in seconds",
      thirdElement: "Customize your blueprint if needed",
    },
  },
};

export const bigBlueprintBannerPtBr = {
  [pageNameKey]: {
    smallOrangeText: "Exclusivo Tomorrow Things",
    gradientText: "A maneira mais fácil de coletar seus dados relevantes",
    findBlueprintButton: "Encontrar blueprint",
    findBlueprintButtonText: "Encontrar blueprint",
    bluePrintExampeAltText: "Exemplo de Blueprint",
    grayNotificationText:
      "Você pode restaurar sua estrutura atual a qualquer momento.",
    grayNotificationAltText: "Cadeado cinza",
    checkedList: {
      firstElement: "Centenas de modelos pré-configurados",
      secondElement: "Aplicado e conectado automaticamente em segundos",
      thirdElement: "Personalize seu blueprint, se necessário",
    },
  },
};

export const bigBlueprintBannerDe = {
  [pageNameKey]: {
    smallOrangeText: "Exklusiv bei TomorrowThings",
    gradientText: "Einfachste Möglichkeit, Ihre relevanten Daten zu sammeln",
    findBlueprintButton: "Blueprint finden",
    findBlueprintButtonText: "Blueprint finden",
    bluePrintExampeAltText: "Beispiel-Blueprint",
    grayNotificationText:
      "Sie können Ihre aktuelle Struktur jederzeit wiederherstellen.",
    grayNotificationAltText: "Graues Schloss",
    checkedList: {
      firstElement: "Hunderte vorkonfigurierter Blueprints",
      secondElement: "Angewendet und automatisch in Sekunden verbunden",
      thirdElement: "Passen Sie Ihren Blueprint bei Bedarf an",
    },
  },
};

export const bigBlueprintBannerZhHans = {
  [pageNameKey]: {
    smallOrangeText: "Tomorrow Things 独家",
    gradientText: "收集相关数据的最简单方法",
    findBlueprintButton: "查找蓝图",
    findBlueprintButtonText: "查找蓝图",
    bluePrintExampeAltText: "蓝图示例",
    grayNotificationText: "您可以随时恢复当前结构。",
    grayNotificationAltText: "灰色锁",
    checkedList: {
      firstElement: "数百个预配置的蓝图",
      secondElement: "几秒钟内应用并自动连接",
      thirdElement: "如有需要，可自定义您的蓝图",
    },
  },
};

export const bigBlueprintBannerIt = {
  [pageNameKey]: {
    smallOrangeText: "Esclusiva Tomorrow Things",
    gradientText:
      "Il modo più semplice per raccogliere i tuoi dati più rilevanti",
    findBlueprintButton: "Trova il Blueprint",
    findBlueprintButtonText: "Trova il Blueprint",
    bluePrintExampeAltText: "Esempio di Blueprint",
    grayNotificationText:
      "Puoi ripristinare la tua struttura attuale in qualsiasi momento.",
    grayNotificationAltText: "Lucchetto grigio",
    checkedList: {
      firstElement: "Centinaia di progetti preconfigurati",
      secondElement: "Applicato e collegato automaticamente in pochi secondi",
      thirdElement: "Personalizza il tuo progetto se necessario",
    },
  },
};

export const bigBlueprintBannerEs = {
  [pageNameKey]: {
    smallOrangeText: "Mañana Things Exclusive",
    gradientText: "La forma más fácil de recopilar tus datos relevantes",
    findBlueprintButton: "Buscar plano",
    findBlueprintButtonText: "Buscar plano",
    bluePrintExampeAltText: "Ejemplo de plano",
    grayNotificationText:
      "Puedes restaurar tu estructura actual en cualquier momento.",
    grayNotificationAltText: "Bloqueo gris",
    checkedList: {
      firstElement: "Cientos de plantillas preconfiguradas",
      secondElement: "Aplicado y conectado automáticamente en segundos",
      thirdElement: "Personaliza tu plano si es necesario",
    },
  },
};

export const bigBlueprintBannerNl = {
  [pageNameKey]: {
    findBlueprintButtonText: "Blueprint zoeken",
    bluePrintExampeAltText: "Blueprint-voorbeeld",
    checkedList: {
      firstElement: "Honderden vooraf geconfigureerde blueprints",
      secondElement:
        "Toegepast en automatisch binnen enkele seconden verbonden",
      thirdElement: "Pas uw blueprint aan indien nodig",
    },
    findBlueprintButton: "Blueprint zoeken",
    gradientText:
      "De eenvoudigste manier om uw relevante gegevens te verzamelen",
    grayNotificationAltText: "Grijs slot",
    grayNotificationText:
      "U kunt uw huidige structuur op elk moment herstellen.",
    smallOrangeText: "Exclusief bij TomorrowThings",
  },
};

export const bigBlueprintBannerTr = {
  [pageNameKey]: {
    bluePrintExampeAltText: "Taslak Örneği",
    findBlueprintButton: "Planı Bul",
    findBlueprintButtonText: "Planı Bul",
    checkedList: {
      firstElement: "Yüzlerce önceden yapılandırılmış plan",
      secondElement: "Saniyeler içinde uygulanır ve otomatik olarak bağlanır",
      thirdElement: "Gerekirse planınızı özelleştirin",
    },
    gradientText: "İlgili verilerinizi toplamanın en kolay yolu",
    grayNotificationAltText: "Gri Kilit",
    grayNotificationText:
      "Mevcut yapınızı istediğiniz zaman geri yükleyebilirsiniz.",
    smallOrangeText: "Yarına Özel Şeyler",
  },
};
